export default "__VITE_ASSET__CiFCSbs5__"